// src/dashboard/ClientResponses.js
import { useState } from 'react';
import { MessageSquare, User, BarChart } from 'lucide-react';
import { Link } from 'react-router-dom';

const ClientResponses = ({ profile }) => {
  const [expandedResponse, setExpandedResponse] = useState(null);

  if (!profile || !profile.responses || profile.responses.length === 0) {
    return (
      <div className="text-center py-8">
        <div className="rounded-full bg-yellow-100 w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <MessageSquare className="text-yellow-600" size={32} />
        </div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">No Responses Found</h3>
        <p className="text-gray-600 mb-6">
          You haven't completed the assessment questionnaire yet.
        </p>
        <Link
          to="/client-assessment"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 inline-block"
        >
          Take the Assessment
        </Link>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Your Assessment Responses</h2>
      
      <div className="space-y-4">
        {profile.responses.map((item, index) => (
          <div 
            key={index} 
            className="border border-gray-200 rounded-md overflow-hidden"
          >
            <div 
              className="p-4 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors flex justify-between items-center"
              onClick={() => setExpandedResponse(expandedResponse === index ? null : index)}
            >
              <h3 className="font-medium text-gray-700">
                {item.question}
              </h3>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className={`h-5 w-5 text-gray-500 transition-transform ${expandedResponse === index ? 'transform rotate-180' : ''}`}
                viewBox="0 0 20 20" 
                fill="currentColor"
              >
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
            
            {expandedResponse === index && (
              <div className="p-4 bg-white border-t border-gray-200">
                <p className="text-gray-600 whitespace-pre-wrap">{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      
      {/* Navigation links at the bottom */}
      <div className="mt-8 pt-6 border-t border-gray-200 flex flex-wrap justify-between gap-3">
        <Link
          to="/client-profile"
          className="text-blue-600 hover:underline flex items-center"
        >
          <User size={16} className="mr-1" />
          <span>Back to profile</span>
        </Link>
        
        {profile.personalityProfile ? (
          <Link
            to="/client-profile/personality"
            className="text-blue-600 hover:underline flex items-center"
          >
            <BarChart size={16} className="mr-1" />
            <span>View personality profile</span>
          </Link>
        ) : (
          <span className="text-gray-400 flex items-center cursor-not-allowed">
            <BarChart size={16} className="mr-1" />
            <span>Personality profile not generated</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default ClientResponses;